import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const XPost = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14942)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#FEF2F2"
          />
          <path
            d="M137.948 96.9033H96.0043L72.0364 114.879V96.9033H60.0525C56.8568 96.9033 54.0605 94.1073 54.0605 90.9112V30.992C54.0605 27.7962 56.8568 25 60.0525 25H137.948C141.144 25 143.94 27.7962 143.94 30.992V90.9112C143.94 94.1073 141.144 96.9033 137.948 96.9033Z"
            fill="white"
            stroke="black"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="63"
            y="61.9395"
            width="77"
            height="4"
            rx="1"
            fill="#1E1E1E"
          />
          <rect
            x="63"
            y="69.9395"
            width="61"
            height="4"
            rx="1"
            fill="#1E1E1E"
          />
          <rect
            x="63"
            y="77.9395"
            width="43"
            height="4"
            rx="1"
            fill="#1E1E1E"
          />
          <circle
            cx="67"
            cy="38.9395"
            r="4"
            fill="#1E1E1E"
          />
          <rect
            x="75"
            y="36.9395"
            width="38"
            height="4"
            rx="1"
            fill="#1E1E1E"
          />
          <rect
            x="117"
            y="36.9395"
            width="20"
            height="4"
            rx="1"
            fill="#1E1E1E"
          />
          <path
            d="M117.353 108.171H147.821L165.232 121.229V108.171H173.937C176.258 108.171 178.29 106.14 178.29 103.818V60.2921C178.29 57.9707 176.258 55.9395 173.937 55.9395H117.353C115.031 55.9395 113 57.9707 113 60.2921V103.818C113 106.14 115.031 108.171 117.353 108.171Z"
            fill="white"
            stroke="black"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M142.85 94.8853C143.983 96.1109 145.914 96.1302 147.072 94.9274L159.738 81.7648C162.349 79.1532 162.929 75.0908 161.479 71.6086C158.867 66.3855 151.613 65.2248 147.55 69.2872L145.229 71.6086L142.907 69.2872C138.555 64.9346 131.59 66.0953 128.979 71.6086C127.238 75.0908 127.818 79.1532 130.72 81.7648L142.85 94.8853Z"
            fill="#FF5A4F"
            stroke="black"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M144 50.9395H54V48.9395H144V50.9395Z"
            fill="black"
          />
          <rect
            x="157.75"
            y="10.75"
            width="52.5"
            height="52.5"
            rx="26.25"
            fill="white"
          />
          <rect
            x="157.75"
            y="10.75"
            width="52.5"
            height="52.5"
            rx="26.25"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M193.541 26.7351C193.625 26.8134 193.693 26.9076 193.741 27.0122C193.788 27.1168 193.815 27.2297 193.819 27.3446C193.823 27.4595 193.805 27.5741 193.764 27.6818C193.724 27.7895 193.663 27.8883 193.585 27.9723L186.466 35.6067L194.323 46.0367C194.421 46.1666 194.48 46.3212 194.495 46.4831C194.51 46.645 194.479 46.8078 194.407 46.9533C194.334 47.0988 194.222 47.2211 194.084 47.3067C193.946 47.3922 193.786 47.4375 193.624 47.4376H188.831C188.695 47.4377 188.561 47.4062 188.44 47.3458C188.319 47.2854 188.213 47.1976 188.132 47.0893L182.602 39.7507L175.694 47.1593C175.536 47.3291 175.317 47.429 175.085 47.4371C174.853 47.4453 174.627 47.3609 174.457 47.2026C174.288 47.0444 174.188 46.8252 174.18 46.5932C174.172 46.3613 174.256 46.1356 174.414 45.9658L181.533 38.3315L173.676 27.9015C173.578 27.7716 173.518 27.6171 173.504 27.4553C173.489 27.2934 173.519 27.1307 173.592 26.9853C173.664 26.8398 173.776 26.7174 173.914 26.6318C174.052 26.5462 174.211 26.5008 174.374 26.5006H179.168C179.303 26.5007 179.437 26.5321 179.558 26.5926C179.679 26.653 179.785 26.7407 179.866 26.8488L185.396 34.1875L192.303 26.7788C192.381 26.6947 192.475 26.6268 192.58 26.579C192.684 26.5313 192.797 26.5046 192.912 26.5005C193.027 26.4965 193.142 26.5151 193.249 26.5553C193.357 26.5956 193.457 26.6567 193.541 26.7351ZM184.66 36.1186C184.635 36.09 184.612 36.0599 184.591 36.0285L178.731 28.2497H176.128L189.266 45.6885H191.87L184.66 36.1186Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_1503_14942">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
